import { Photo } from '@mui/icons-material'
import Dropzone, { DropzoneProps } from './Dropzone'
import { useTranslation } from 'react-i18next'
import { Box, Button, Stack } from '@mui/material'
import { useEffect, useState } from 'react'

export interface AssetPhotoDropzoneProps extends Omit<DropzoneProps, 'onDrop'> {
  value?: File | null
  onChange?: (file: File | null) => void
}

export default function AssetPhotoDropzone({
  value,
  label,
  buttonText,
  onChange,
  ...props
}: AssetPhotoDropzoneProps) {
  /**
   * The tranlate function.
   */
  const { t } = useTranslation('asset')

  /**
   * The image URL.
   */
  const [imageUrl, setImageUrl] = useState<string | null>(null)

  function handleDrop(files: File[]) {
    if (files.length > 0 && files[0].type.startsWith('image/')) {
      onChange?.(files[0])
    }
  }

  function handleRemove() {
    onChange?.(null)
  }

  useEffect(() => {
    if (value) {
      setImageUrl(URL.createObjectURL(value))
    } else {
      setImageUrl(null)
    }

    return () => setImageUrl(null)
  }, [value])

  return (
    <>
      {imageUrl ? (
        <>
          <Box
            minHeight={200}
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              borderRadius: 1,
              width: '100%',
              cursor: 'pointer'
            }}
          >
            <img src={imageUrl} style={{ width: '100%', height: 'auto' }} />
          </Box>
          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 1 }}>
            <Button variant="text" color="error" onClick={handleRemove}>
              {t('removePhoto')}
            </Button>
          </Stack>
        </>
      ) : (
        <Dropzone
          icon={<Photo color="disabled" sx={{ fontSize: 48 }} />}
          label={label ?? t('takePhotoOfTheInstalledAsset')}
          buttonText={buttonText ?? t('selectPhoto')}
          onDrop={handleDrop}
          {...props}
        />
      )}
    </>
  )
}
